import { OperatoryDetails } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/operatory.pb';
import { IconName } from '@frontend/icons';
import { OPERATORY_COLORS, OPERATORY_COUNT_ICONS } from './constant';
/**
 * Simple hash function to convert a string to a number
 */
function _hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
}

export type OperatoryAvatarInfo = {
  color: string;
  icon: IconName;
};

/**
 * Gets a consistent color and icon for an operatory based on its name
 * @param operatoryName - The name of the operatory
 * @returns An object containing the assigned color and icon
 */
export function getOperatoryAvatarInfoByName(
  operatoryName?: string,
  existingAvatarInfo?: OperatoryDetails['icon']
): OperatoryAvatarInfo {
  if (existingAvatarInfo?.color && existingAvatarInfo?.name) {
    return {
      color: existingAvatarInfo.color,
      icon: existingAvatarInfo.name as IconName,
    };
  }

  if (!operatoryName || operatoryName.trim() === '') {
    // Return default values for empty names
    return {
      color: OPERATORY_COLORS[OPERATORY_COLORS.length - 1],
      icon: 'wellness',
    };
  }

  const normalizedName = operatoryName.toLowerCase().trim();
  const hash = _hashString(normalizedName);

  const colorIndex = hash % OPERATORY_COLORS.length;
  const iconIndex = hash % OPERATORY_COUNT_ICONS.length;

  return {
    color: OPERATORY_COLORS[colorIndex],
    icon: OPERATORY_COUNT_ICONS[iconIndex],
  };
}
